module.exports = __webpack_public_path__ + "static/media/jaba-2.3c118bcd.jpg";